// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__0CYpA","link":"style_link__7y_bt"};